import { render, staticRenderFns } from "./FormGroupUploadImages.vue?vue&type=template&id=362855a4"
import script from "./FormGroupUploadImages.vue?vue&type=script&lang=js"
export * from "./FormGroupUploadImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInputs: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/form/FormInputs.vue').default})
